export default "Friend: did you see the email?\nYou: yeah, total disaster lol\nFriend: 😬\nYou: gonna have to do damage control monday\n"